<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Clone User</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="full-grow-no-shrink-no-basis">
    <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="cloneUserForm">
      <div class="flex flex-col flex-1-0-auto">

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Select Company</mat-label>
            <mat-select required formControlName="companyModel">
              <mat-option *ngFor="let company of companies" [value]="company.companyId">
                {{ company.companyName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="cloneUserFormErrors.companyModel.hasOwnProperty('required')">
              Company is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Email Address</mat-label>
            <input matInput required formControlName="email"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input">
            <mat-error *ngIf="cloneUserFormErrors.email.hasOwnProperty('required')">
              Email address is required.
            </mat-error>
            <mat-error *ngIf="cloneUserFormErrors.email.hasOwnProperty('pattern')">
              Email address must be valid.
            </mat-error>
          </mat-form-field>
        </div>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
    </button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="!cloneUserForm.valid" cdkFocusInitial>Save
    </button>
  </mat-dialog-actions>
</div>
